import React, {useEffect, useState} from 'react';
import { Dropdown } from 'react-bootstrap';

const FormDropdown = ({item, index, global, setForm} ) => {
    const [options,setOptions] = useState([])

    useEffect(() => {
        if(item.key === 'taxation_system'){
            setOptions(global.tax)
        }else if(item.key === 'packages'){
            setOptions(global.package)

        }else if(item.key === 'category'){
            setOptions(item.option)

        }
    },[item,global])
    const _getValue = (data, key) => {
        let result = data;
        let path = key.split(".")
        for (let index = 0; index < path.length; index++) {
            const element = path[index];
            result = result[element]
        }
        return result === data ? null : result;
    }

    const onChange = (selectedItem, value) => {
        setForm(prevForm =>
            prevForm.map(formItem =>{
                return formItem.key === selectedItem.key
                    ? { ...formItem, value, label: selectedItem.name, active: false, valid: !!value }
                    : formItem
                }


            )
        );
    };

    return(
        <div key={index} className="company-dropdown">
            <Dropdown>
                <Dropdown.Toggle>{item.value && item.key !== "category" ? options.find(o => o.url === item.value)?.name :options.find(o => o.id === item.value)?options.find(o => o.id === item.value).name  :"Select an option"}</Dropdown.Toggle>
                <Dropdown.Menu>
                    {options?.map(opt => (
                        <Dropdown.Item key={opt.id} onClick={() => onChange(item, opt.url || opt.id)}>
                            {opt.name}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            {!item.valid && <div className="validation">{item.errorMessage}</div>}
        </div>
    )
};

export default FormDropdown;